import { RequestStatus } from "request";

export interface SubCompany {
  id: number;
  companyName: string;
  primaryInvoiceEmail: string | null;
  appIds: string[] | null;
}

export interface SubCompaniesState {
  companies: SubCompany[];
  fetchCompaniesRequestState: RequestStatus;
}

export const initialState: SubCompaniesState = {
  companies: [],
  fetchCompaniesRequestState: {
    isLoading: false,
    isSuccessful: false,
    isFailed: false,
  },
};
